
import { SET_CURRENT_MARKETING, SET_MARKETING_ALL, RESET_MARKETING, SET_MARKETING_PRODUCT_LIST } from '../actions/type';


const initialState = {
  marketingAll: [],
  currentMarket: null,
  marketingProductList:[]
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MARKETING_ALL:
      return {
        ...state,
        marketingAll:action.payload.data,
      };
    case SET_MARKETING_PRODUCT_LIST:
      return {
        ...state,
        marketingProductList:action.payload.data,
      };
    case SET_CURRENT_MARKETING:
      return {
        ...state,
        currentMarket:action.payload.data,
      };
    case RESET_MARKETING:
      return {
        ...state,
        marketingAll:[],
        currentMarket: null,
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./master/jsx/reducers/market_reducer.js